export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8877.21fae286.jpg";